/**
 * mobileDetect.js — shared mobile-width detection (port of the UK app's
 * constituencyprofiles/frontend/src/utils/mobileDetect.js).
 *
 * Used by App.js's <MobileRedirect/> to decide whether a phone user should be
 * auto-redirected to /m. Desktop-width users fail isMobileDevice() → the redirect
 * early-returns before any fetch/navigation, so desktop is completely untouched.
 *
 * Three-signal approach:
 *   1. window.innerWidth / matchMedia  — correct for normal mobile browsers
 *   2. screen.width + UA               — fallback for "Request Desktop Site" mode,
 *      which overrides the viewport (innerWidth → ~1280) but not screen.width
 */
const BREAKPOINT = 900;

export function isMobileDevice() {
  const narrowViewport =
    window.innerWidth < BREAKPOINT ||
    window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`).matches;
  const mobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const narrowScreen = window.screen.width < BREAKPOINT;
  return narrowViewport || (mobileUA && narrowScreen);
}

/**
 * shouldGoMobile — true when the auto-redirect would fire: a mobile device AND the
 * user hasn't opted into desktop (Stage 1's "View desktop site" sets preferDesktop).
 */
export function shouldGoMobile() {
  return isMobileDevice() && localStorage.getItem("preferDesktop") !== "true";
}
